import React, { useEffect, useState, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import "./../ThankyouPage.scss";
import "../../../../general.scss";
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';

export function UserSignin(props) {

   
    const postCompleteUrl = sessionStorage.getItem("postcompleteurl-default");
    const { t, i18n } = useTranslation();
    const {customThankyouMessage, customButtonText, order}= props;
    const [confirmationText, setConfirmationText] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [canBeOverridden, setCanBeOverridden] = useState(true);
    const [isCorporate, setIsCorporate]= useState("")
    const [route, setRoute]=useState("")
    const hasRunRef = useRef(false);
    const navigate = useNavigate();

    //set values to settings that manipulate the confirmationTextBlock(corp/non corp, renewal/non renewal, slots/noslots)
    useEffect(() => {
        if (!order) return;
    
        const slotData = order?.slotdata;
        const isRenewal = order.isrenewal ?? false;
        const isCorporate = !!slotData;
        // const canAddUsers = !!slotData?.some(sd => sd?.numberOfSlots > sd?.filledSlots);
    
        if (!hasRunRef.current) {
            getValuesForMessageBlock({ isRenewal, isCorporate});
            hasRunRef.current = true;
        }

    }, [order]);

    
    const getValuesForMessageBlock = ({ isRenewal, isCorporate }) => {

        if (isCorporate) { 

            setIsCorporate(true);

            if(isRenewal){

                //renewal
                setConfirmationText(t("thankyoupage.managerecipientcorporate.defaultmessage"));
                setButtonText(t("thankyoupage.managerecipientcorporate.buttontext"));

            }else{

                //new order
                setConfirmationText(t("thankyoupage.addrecipientcorporate.defaultmessage"));
                setButtonText(t("thankyoupage.addrecipientcorporate.buttontext"));
            }
            
        } else {

            setIsCorporate(false);
            setConfirmationText(t("thankyoucontinue.defaultmessage"));
            setButtonText(t("thankyoucontinue.buttontext"));
        }
    };

    const showCustomMessage = customThankyouMessage.show === "true" && canBeOverridden;
    const showCustomButtonText = customButtonText.show === "true" && canBeOverridden; 

    const redirectToManageUserPage=()=>{

        navigate("/managerecipients/"+ order.id, { state: { url: postCompleteUrl }}) 

    }

    return (
         <div className="item-container">
             <div className="with-button">
                   <div className="item-container">
                        {showCustomMessage ? <p className="large subtext" dangerouslySetInnerHTML={{ __html:  DOMPurify.sanitize(customThankyouMessage.text)}}></p>
                         : <p className="large subtext" dangerouslySetInnerHTML={{ __html:  DOMPurify.sanitize(confirmationText)}}></p> }
                    </div>

                {isCorporate ?  

                    <button className="primary-button" onClick={redirectToManageUserPage}>
                      {showCustomButtonText ? customButtonText.text : buttonText}
                    </button>

                    :
                    <a className="primary-button" href={postCompleteUrl} >
                        {showCustomButtonText ? customButtonText.text : buttonText}
                    </a>}

                </div></div>
        
    )
}



